import styled from "styled-components";

import StandardLayout from "@/components/layouts/Authenticated/StandardLayout";
import { Tab } from "@/components/molecules/Tabs";
import { breakpoints } from "@/styles/breakpoints";
import { StyledTableContainer } from "@/styles/components";

export const StyledHome = styled.div`
    @media ${breakpoints.xs} {
        margin: 0 auto;
    }
`;

export const StyledHomeContainerRow = styled.div`
    display: flex;
    justify-content: center;
    @media ${breakpoints.sm} {
        justify-content: space-around;
    }

    @media ${breakpoints.xs} {
        display: block;
    }
`;

export const StyledHomeContainerCol = styled.div`
    @media ${breakpoints.mdMax} {
        width: 50%;
        &:first-child {
            margin-right: 40px;
        }
    }

    @media ${breakpoints.sm} {
        width: 50%;
        &:first-child {
            margin-right: 1.5%;
        }
    }
    @media ${breakpoints.xs} {
        width: 100%;
        &:first-child {
            margin-right: 0;
        }
    }
    @media ${breakpoints.md} {
        width: 50%;
        &:first-child {
            margin-right: 62px;
        }
    }
    @media ${breakpoints.lg} {
        width: 50%;
        &:first-child {
            margin-right: 72px;
        }
    }

    .infWrapper {
        @media ${breakpoints.xs} {
            display: block;
        }
    }

    .column {
        @media ${breakpoints.xs} {
            display: block;
            padding-left: 0;
        }
    }
`;

export const StyledHomesection = styled.div`
    margin-right: auto;
    margin-bottom: 40px;
    margin-left: auto;
    border-radius: var(--radius-10);
    @media ${breakpoints.xs} {
        margin-bottom: 32px;
    }
`;

export const StyledDashboardContainer = styled(StandardLayout)`
    .filterRow {
        margin-top: 24px;
        margin-bottom: 24px;

        &:empty {
            display: none;
        }
    }
`;

export const StyledSeeAllButton = styled.button`
    font-size: var(--size-14);
    font-weight: bold;
    line-height: 25px;
    color: var(--color-secondary);
    text-transform: uppercase;
    cursor: pointer;
    background-color: transparent;
    border: none;
    text-align: center;
`;

export const StyledDashboardTabsPanel = styled.div<{ $withoutTabs: boolean }>`
    text-align: center;
    background-color: var(--color-secondary-light);
    border-radius: ${(props) => (props.$withoutTabs ? "10px" : "0 var(--radius-10) var(--radius-10) var(--radius-10)")};
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);

    .bodyWrapper {
        text-align: left !important;
    }

    .MuiBox-root {
        padding: 16px;
    }

    .MuiTableContainer-root,
    .MuiTableRow-head,
    .MuiTableRow-root {
        background-color: transparent;
        border-radius: 4px;
    }

    .MuiTableRow-head,
    .MuiTableRow-root {
        border-bottom: 2px solid var(--color-secondary-light);
    }

    .MuiTableHead-root .MuiTableCell-root {
        background-color: var(--color-selected) !important;
    }

    .MuiTableBody-root .MuiTableCell-root {
        background-color: white;
    }

    .MuiTableCell-root:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .MuiTableCell-root:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    ${StyledTableContainer} {
        margin-bottom: 16px;
    }
`;

StyledDashboardTabsPanel.defaultProps = {
    $withoutTabs: false,
};

export const StyledDashboardTab = styled(Tab)`
    && {
        font-size: var(--size-14) !important;
    }
`;
